import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import { HTTP as axios } from './axios/axios';
import VueProgressiveImage from 'progressive-image/dist/vue';

Vue.prototype.$http = axios;

Vue.use( Vuex );
Vue.use( VueRouter );
Vue.use( VueProgressiveImage, {
	removePreview: true
} );

Vue.config.debug = true;
Vue.config.devTools = true;

//Import all vue components


// COMPONENTES PORTADA
import slideportada from './components/slideportada.vue';
Vue.component( 'slideportada', slideportada );
import audiosportada from './components/audiosportada.vue';
Vue.component( 'audiosportada', audiosportada );
import img_linkportada from './components/img_linkportada.vue';
Vue.component( 'imglinkportada', img_linkportada );
import categoriaportada from './components/categoriaportada.vue';
Vue.component( 'categoriaportada', categoriaportada );
import encuestasportada from './components/encuestasportada.vue';
Vue.component( 'encuestasportada', encuestasportada );
import proximosprogramas from './components/proximosprogramas.vue';
Vue.component( 'proximosprogramas', proximosprogramas );
import versiculosdeldia from './components/versiculodeldia.vue';
Vue.component( 'versiculosdeldia', versiculosdeldia );
import portada from './components/portada.vue';
Vue.component( 'portada', portada );

// ARCHIVES
import catpodcast from './components/catpodcast.vue';
Vue.component( 'catpodcast', catpodcast );

// SINGLE PODCAST
import interna_podcast from './components/interna_podcast.vue';
Vue.component( 'interna_podcast', interna_podcast );


import allcats from './components/allcats.vue';
Vue.component( 'allcats', allcats );

// LOCUTORES
import locutores from './components/locutores.vue';
Vue.component( 'locutores', locutores );
import locutor from './components/locutor.vue';
Vue.component( 'locutor', locutor );

// PROGRAMAS
import programas from './components/programas.vue';
Vue.component( 'programas', programas );
import programa from './components/programa.vue';
Vue.component( 'programa', programa );


// PAGINAS
import page from './components/page.vue';
Vue.component( 'page', page );
import page_formulario from './components/page_formulario.vue';
Vue.component( 'page_formulario', page_formulario );
import page_iconos from './components/page_iconos.vue';
Vue.component( 'page_iconos', page_iconos );
import page_historia from './components/page_historia.vue';
Vue.component( 'page_historia', page_historia );
import page_pioneros from './components/page_pioneros.vue';
Vue.component( 'page_pioneros', page_pioneros );
import page_opiniones from './components/page_opiniones.vue';
Vue.component( 'page_opiniones', page_opiniones );
import page_mapa from './components/page_mapa.vue';
Vue.component( 'page_mapa', page_mapa );



import posts from './components/posts.vue';
Vue.component( 'posts', posts );
import post from './components/post.vue';
Vue.component( 'post', post );
import header from './components/theme-header.vue';
Vue.component( 'theme-header', header );
import footer from './components/theme-footer.vue';
Vue.component( 'theme-footer', footer );
import category from './components/category.vue';
Vue.component( 'category', category );
import tag from './components/tag.vue';
Vue.component( 'tag', tag );

//Buscador
import buscador from './components/_buscador.vue';
Vue.component( 'buscador', buscador );
//SEARCH EXAMPLE
import search from './components/search.vue';
Vue.component( 'search', search );

//NEW Podcast
import podcast from './components/podcast.vue';
Vue.component( 'podcast', podcast );

//NEW SINGLE PODCAST
import new_interna_podcast from './components/new_interna_podcast.vue';
Vue.component( 'interna_podcast', new_interna_podcast );

//NEW ARCHIVE PODCAST
import archive_podcast from './components/archive_podcast.vue';
Vue.component( 'archive_podcast', archive_podcast );

//NEW SINGLE VERSICULO
import interna_versiculo from './components/interna_versiculo.vue';
Vue.component( 'interna_versiculo', interna_versiculo );

//NEW ARCHIVE REFELXIONES
import archive_reflexiones from './components/archive_reflexiones.vue';
Vue.component( 'archive_reflexiones', archive_reflexiones );

//NEW SINGLE REFELXIONES
import interna_reflexion from './components/interna_reflexion.vue';
Vue.component( 'interna_reflexion', interna_reflexion );

const App = Vue.extend( {
	template: '<div><theme-header></theme-header>' +
			'<router-view></router-view>' +
			'<theme-footer></theme-footer></div>',
	computed: {
	}
} );




//Define route for vue app
//ref : http://router.vuejs.org/en/
const router = new VueRouter( {
	mode: 'history',
	routes: [
		{ path: '/', name: 'Inicio', component: portada },
		{ path: '/programas', name: 'programas', component: programas },
		{ path: '/programas/:elprograma', name: 'programa', component: programa },
		{ path: '/locutores/:locutor', name: 'locutor', component: locutor },
		{ path: '/locutores', name: 'locutores', component: locutores },
		{ path: '/categoria/', name: 'allcats', component: allcats },
		{ path: '/categoria/podcast', name: 'catpodcast', component: podcast },
		{ path: '/categoria/podcast/:name', name: 'interna_podcast', component: new_interna_podcast },
		{ path: '/categoria/:name', name: 'cat', component: category },
		{ path: '/category/podcast', name: 'catpodcast', component: catpodcast },
		{ path: '/category/podcast/:name', name: 'interna_podcast', component: new_interna_podcast },
		{ path: '/category/:name', name: 'cat', component: category },
		{ path: '/tag/:name', name: 'tag', component: tag },
		{ path: '/:name', name: 'post', component: post },
		// { path: '/:page(\\d+)?', name: 'home', component: posts },
		{ path: '/page/:name', name: 'page', component: page },
		{ path: '/portada', name: 'Inicio', component: portada },
		{ path: '/search/:s', name : 'search', component: search }, //NEW
		{ path: '/podcast/archive', name:'archive_podcast', component: archive_podcast }, //NEW
		{ path: '/versiculo/:elversiculo', name: 'interna_versiculo',  component: interna_versiculo }, //NEW
		{ path: '/reflexiones/archive', name:'archive_reflexiones', component: archive_reflexiones }, //NEW
		{ path: '/interna_reflexion/:name', name:'interna_reflexion',  component: interna_reflexion }, //NEW
	]
} );

//Define vuex store
const store = new Vuex.Store( {
	state: {
		title: ''
	},
	mutations: {
		rtChangeTitle( state, value ) {
			// mutate state
			state.title = value;
			document.title = ( state.title ? state.title + ' - ' : '' ) + rtwp.site_name;
		}
	}
} );

//Create instance of main component
new App( {
	store,
	router
} ).$mount( '#app' );




// WEBPACK FOOTER //
// ./src/main.js